module.exports = __webpack_public_path__ + "fa557e60430f9c7897897110c1a8dcff.svg";